/* Change a CAMBIO bundle by exact cart keys, without exposing orphaned children. */
(function (scope) {
  'use strict';
  const order = item => String(item.properties?._apo_order || '').trim();
  function childLink(item) {
    const match = /^Added by:\s*(.*?)\s*(?:\*\s*(\d+)(.*))?$/.exec(order(item));
    return match ? {order:match[1].trim(), multiplier:Number(match[2] || 1), once:!match[2] || Boolean(match[3]?.trim())} : null;
  }
  function plan(cart, key, quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error('Invalid quantity');
    const parent = cart.items.find(item => item.key === key);
    if (!parent) throw new Error('Cart changed');
    if (childLink(parent) || parent.properties?._apo_added_by) throw new Error('Edit buckles on their shoe');
    const group = order(parent);
    const updates = {[parent.key]:quantity};
    if (group) {
      const otherQuantity = cart.items.filter(item => item.key !== key && order(item) === group).reduce((sum,item)=>sum+item.quantity,0);
      for (const item of cart.items) {
        const link = childLink(item);
        if (!link || link.order !== group) continue;
        const total = quantity + otherQuantity;
        updates[item.key] = link.once ? (total ? link.multiplier : 0) : total * link.multiplier;
      }
    } else if (parent.properties?._apo_variants) {
      // Legacy bundles must be edited with ARIS, never guessed from variant IDs.
      throw new Error('Legacy bundle');
    }
    return {parent,updates};
  }
  if (typeof module === 'object' && module.exports) { module.exports = {plan,childLink}; return; }
  let busy = false;
  let inputTimer;
  let pendingInput;
  const root = () => scope.Shopify?.routes?.root || '/';
  const words = {
    de:'Die Änderung konnte nicht abgeschlossen werden. Bitte laden Sie den Warenkorb neu und prüfen Sie die Mengen.',
    en:'The change could not be completed. Please reload your cart and check the quantities.',
    fr:'La modification n’a pas pu être effectuée. Rechargez votre panier et vérifiez les quantités.',
    nl:'De wijziging kon niet worden voltooid. Vernieuw je winkelwagen en controleer de aantallen.',
    it:'La modifica non è stata completata. Ricarica il carrello e controlla le quantità.'
  };
  async function json(url, options) {
    const response = await fetch(root()+url, options);
    const data = await response.json();
    if (!response.ok || data.status >= 400) {
      const failure=new Error('Cart request failed');
      if (response.status === 422 && typeof data.description === 'string') failure.userMessage=data.description;
      throw failure;
    }
    return data;
  }
  function error(row,message) {
    let node = row.querySelector('[data-lb-bundle-error]');
    if (!node) { node=document.createElement('p'); node.dataset.lbBundleError=''; node.setAttribute('role','alert'); row.append(node); }
    node.textContent=message || words[document.documentElement.lang.split('-')[0]] || words.en;
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  async function change(row,key,quantity) {
    if (busy) return;
    clearTimeout(inputTimer);
    pendingInput=null;
    busy=true;
    document.documentElement.dataset.lbCartBusy='true';
    row.setAttribute('aria-busy','true');
    try {
      const cart=await json('cart.js',{cache:'no-store'});
      const {parent,updates}=plan(cart,key,quantity);
      if (quantity > parent.quantity) {
        // add.js validates stock; update.js does not validate existing line stock.
        const items=cart.items.filter(item => updates[item.key] > item.quantity).map(item=>({
          id:item.variant_id, quantity:updates[item.key]-item.quantity, properties:item.properties,
          ...(item.selling_plan_allocation ? {selling_plan:item.selling_plan_allocation.selling_plan.id} : {})
        }));
        await json('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      } else {
        await json('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
      }
      // Reload from one complete server state. Avoid index-based DOM/cart reconciliation.
      location.reload();
    } catch (e) {
      try {
        const current=await json('cart.js',{cache:'no-store'});
        const item=current.items.find(item=>item.key===key);
        const input=row.querySelector('[data-update-cart]');
        if (item && input) input.value=item.quantity;
      } catch (_) { /* Keep the error visible if the connection is unavailable. */ }
      error(row,e.userMessage); busy=false; delete document.documentElement.dataset.lbCartBusy; row.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click',event=>{
    const control=event.target.closest?.('[data-remove-key],[data-decrease-quantity],[data-increase-quantity]');
    const row=control?.closest('[data-cart-item]');
    if (!row) return;
    stop(event);
    if (busy) return;
    const input=row.querySelector('[data-update-cart]');
    if (!input) return;
    if (row.dataset.lbBundleChild === 'true') return;
    const quantity=control.hasAttribute('data-remove-key') ? 0 : Math.max(0,Number(input.value)+(control.hasAttribute('data-increase-quantity')?1:-1));
    void change(row,input.dataset.updateCart,quantity);
  },true);
  document.addEventListener('change',event=>{
    const input=event.target.closest?.('[data-update-cart]');
    const row=input?.closest('[data-cart-item]');
    if (!row) return;
    stop(event);
    clearTimeout(inputTimer);
    pendingInput=null;
    if (!busy && row.dataset.lbBundleChild !== 'true') void change(row,input.dataset.updateCart,Number(input.value));
  },true);
  document.addEventListener('input',event=>{
    const input=event.target.closest?.('[data-update-cart]');
    const row=input?.closest('[data-cart-item]');
    if (!row || row.dataset.lbBundleChild === 'true') return;
    clearTimeout(inputTimer);
    pendingInput=input;
    inputTimer=setTimeout(()=>{
      if (!busy && input.isConnected && input.value !== '' && input.validity.valid && input.value !== input.defaultValue) {
        void change(row,input.dataset.updateCart,Number(input.value));
      }
    },700);
  },true);
  document.addEventListener('submit',event=>{
    if ((busy || pendingInput) && event.target.matches('form[action*="/cart"]')) {
      stop(event);
      if (!busy && pendingInput) void change(pendingInput.closest('[data-cart-item]'),pendingInput.dataset.updateCart,Number(pendingInput.value));
    }
  },true);
  document.addEventListener('click',event=>{
    if ((busy || pendingInput) && event.target.closest?.('[data-lb-cart-edit],[name="checkout"],a[href*="/checkout"]')) {
      stop(event);
      if (!busy && pendingInput) void change(pendingInput.closest('[data-cart-item]'),pendingInput.dataset.updateCart,Number(pendingInput.value));
    }
  },true);
})(typeof window === 'undefined' ? globalThis : window);
